import { Maybe } from 'graphql/jsutils/Maybe'

const useKeyMeasureRow = (
  data: any,
  subgroup: Maybe<string> | undefined,
  subgroupItem: Maybe<string> | undefined,
  prefix: string,
  suffix: string,
  everStatic: boolean,
  sortBy: 'average' | 'percentile' | 'sort_order'
) => {
  let sortValue = data.sort_order

  let dataIdent = data.type === 'toggledBarChart' ? 'series' : 'values'
  const subgroupData = subgroup
    ? (data.segmentations.filter(
        (s: { name: string }) => s.name === subgroup
      )[0] || {})[dataIdent]
    : null
  let subgroupItemData = null
  if (data.type === 'toggledBarChart') {
    const barData = subgroupData
      ? subgroupData.filter((s: { name: string }) => s.name === subgroupItem)[0]
      : null
    subgroupItemData = barData
      ? {
          name: barData.name,
          value: barData.data[0], //we always assume one category for this data type
        }
      : null
  } else {
    subgroupItemData = subgroupData
      ? subgroupData.filter((s: { name: string }) => s.name === subgroupItem)[0]
      : null
  }

  const currentData =
    data.type === 'toggledBarChart'
      ? data.current[0]?.data[0]
      : data.current.value

  let averageData = `${prefix || ''}${(subgroupItemData
    ? subgroupItemData.value
    : currentData
  )?.toFixed(2)}${suffix || ''}`

  // I don't think we will deal with current static for toggledBarChart data???
  if (data.static_current?.name) {
    averageData = `${prefix || ''}${(subgroupItemData
      ? subgroupItemData.value
      : data.static_current.value
    )?.toFixed(2)}${suffix || ''}`
  } else if (everStatic) {
    averageData = 'N/A'
  }

  // toggledBarChart don't have percentage values, displays 'N/A', should get undefined for data type
  let chartPercentage = null
  if (data.type !== 'toggledBarChart') {
    if (subgroup) {
      chartPercentage = subgroupItemData?.percentage
    } else {
      chartPercentage = data.current.percentage
      if (data.static_current.name || everStatic) {
        chartPercentage = data.static_current.percentage
      }
    }
  }

  if (sortBy === 'average') {
    sortValue = subgroupItemData ? subgroupItemData.value : currentData
    // I don't think we will deal with current static for toggledBarChart data???
    if (data.static_current?.name) {
      sortValue = subgroupItemData
        ? subgroupItemData.value
        : data.static_current.value
    } else if (everStatic) {
      sortValue = data.sort_order
    }
  }

  if (sortBy === 'percentile') {
    sortValue = chartPercentage
  }

  return {
    subgroupItemData,
    averageData,
    chartPercentage,
    sortValue,
  }
}

export default useKeyMeasureRow
